import { useMutation } from '@tanstack/react-query';

import config from 'config';

import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';
import { loadAccessContext } from '../access';
import { useAuthContext } from '../context';

/** Applies the profile returned after the external account's one-time type choice. */
export const useCompleteExternalAccountType = () => {
  const { methods } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.CompleteExternalAccountType.Request) => {
      const { data } = await Api.CompleteExternalAccountType(values);
      return data;
    },
    onSuccess: (data) => {
      methods.setUser(Mappers.User(data.user));
      const orgs = (data.organizations || []).map((org: any) => ({ ...Mappers.Organization(org), role: org.role }));
      methods.setOrganizations(orgs);
      methods.setOrganization(data.organization ? Mappers.Organization(data.organization) : null);
      methods.setRole(data.role);
      if (data.organization) {
        localStorage.setItem(config.api.active_org_key, data.organization.id);
        void loadAccessContext(methods);
      } else {
        methods.setPermissions([]);
        methods.setEntitlements(null);
        methods.setAccessFetched(true);
      }
    },
  });
};
